var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 145,
    viewBox: "0 0 142 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8948 95.8457H51.5314V117.37H18.8948V95.8457Z",
    fill: "#ADCCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7041 20.7295H27.4957C16.5683 20.7295 9.16511 25.3235 9.1652 38.7521C9.16528 50.5616 9.16485 72.6769 9.16479 83.6318H77.8422",
    stroke: "#11161D",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.3418,
    y: 20.4727,
    width: 34.923,
    height: 95.8387,
    rx: 17.4615,
    fill: "#ADCCFF",
    stroke: "#11161D",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3418,
    y: 48.4268,
    width: 34.923,
    height: 73.8746,
    rx: 17.4615,
    fill: "white",
    stroke: "#11161D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.741 95.9996V117.203H52.8776V95.9996M19.741 95.9996H52.8776M19.741 95.9996L36.6618 105.894L52.8776 95.9996M57.8128 84.3379V87.165H71.561V84.3379H57.8128ZM61.6905 88.2251V143H67.6833V88.2251H61.6905Z",
    stroke: "#11161D",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4174 2H58.8706V10.4812H44.4174V2Z",
    fill: "#2966CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8706 46.8797V10.4812M58.8706 10.4812V2H44.4174V10.4812H58.8706Z",
    stroke: "#11161D",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2481 50.0602C61.2481 51.1869 60.3379 52.094 59.2229 52.094C58.1079 52.094 57.1977 51.1869 57.1977 50.0602C57.1977 48.9335 58.1079 48.0264 59.2229 48.0264C60.3379 48.0264 61.2481 48.9335 61.2481 50.0602Z",
    stroke: "#11161D",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55032 93.8795C5.55032 95.0063 4.64015 95.9134 3.52515 95.9134C2.41015 95.9134 1.49998 95.0063 1.49998 93.8795C1.49998 92.7528 2.41015 91.8457 3.52515 91.8457C4.64015 91.8457 5.55032 92.7528 5.55032 93.8795Z",
    stroke: "#11161D",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.712 23.556C141.712 24.5318 140.923 25.3229 139.949 25.3229C138.976 25.3229 138.187 24.5318 138.187 23.556C138.187 22.5801 138.976 21.7891 139.949 21.7891C140.923 21.7891 141.712 22.5801 141.712 23.556Z",
    fill: "#11161D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3418,
    y: 47.4287,
    width: 61.1581,
    height: 34.4587,
    fill: "white",
    stroke: "#11161D",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8994 48.0488L109.216 64.3045L140.59 48.0488",
    stroke: "#11161D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBox);
export default __webpack_public_path__ + "static/media/emailBox.e1dc0e467875a1f2627dacbede1debb6.svg";
export { ForwardRef as ReactComponent };